import { useEffect, useMemo, useRef } from "react";
import { sendReadReceiptUpdate } from "../websocket/webSocketRequests";
import { getChatSocket } from "../websocket/webSocketConnection";

function maxMessageSeq(messages) {
  if (!Array.isArray(messages)) return 0;
  let max = 0;
  for (const m of messages) {
    const s = m?.messageSeq;
    if (typeof s === "number" && s > 0 && s > max) max = s;
  }
  return max;
}

/** 방 전환 직후 이전 방 messages가 남아 있을 때 잘못된 seq로 읽음 보내지 않도록 roomId로 필터 */
function maxMessageSeqForRoom(messages, roomId) {
  if (!Array.isArray(messages) || !roomId) return 0;
  const anyTagged = messages.some((m) => m?.roomId != null && m.roomId !== "");
  if (!anyTagged) return maxMessageSeq(messages);
  let max = 0;
  for (const m of messages) {
    if (m?.roomId != null && m.roomId !== roomId) continue;
    const s = m?.messageSeq;
    if (typeof s === "number" && s > 0 && s > max) max = s;
  }
  return max;
}

/**
 * 채팅방 화면에서 서버에 읽음 위치 반영 (ROOM.READ_RECEIPT). 말풍선 읽음 표시 없음.
 */
export function useMarkRoomRead(roomId, isChatRoomActive, messages) {
  const lastSentSeqRef = useRef(0);

  useEffect(() => {
    lastSentSeqRef.current = 0;
  }, [roomId]);

  const maxSeq = useMemo(() => maxMessageSeqForRoom(messages, roomId), [messages, roomId]);

  useEffect(() => {
    if (!isChatRoomActive || !roomId) return;
    if (maxSeq <= 0) return;
    if (maxSeq <= lastSentSeqRef.current) return;

    const trySend = () => {
      const sock = getChatSocket();
      if (!sock) return false;
      return sendReadReceiptUpdate(sock, roomId, maxSeq);
    };

    if (trySend()) {
      lastSentSeqRef.current = maxSeq;
      return;
    }

    const t = setTimeout(() => {
      if (maxSeq <= lastSentSeqRef.current) return;
      if (trySend()) lastSentSeqRef.current = maxSeq;
    }, 400);

    return () => clearTimeout(t);
  }, [roomId, isChatRoomActive, maxSeq]);
}
